import '@fontsource/space-grotesk/300.css';
import '@fontsource/space-grotesk/400.css';
import '@fontsource/space-grotesk/500.css';
import '@fontsource/space-grotesk/600.css';
import '@fontsource/space-grotesk/700.css';
import '@fontsource/cinzel/400.css';
import '@fontsource/cinzel/500.css';
import '@fontsource/cinzel/600.css';
import '@fontsource/cinzel/700.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';

import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import './styles/global.css';

const root = document.getElementById('root')!;
const tree = (
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);

// Prerendered pages carry a marker naming the route their HTML was rendered
// for (see vite-plugins/prerender.ts). Hydrate only when it matches the URL
// we're actually on — dist/index.html doubles as the SPA fallback for
// non-prerendered URLs, where hydrating would mismatch.
const marker = document
  .querySelector('meta[name="prerender-route"]')
  ?.getAttribute('content');
const current = window.location.pathname.replace(/\/+$/, '') || '/';

if (marker && marker === current && root.firstChild) {
  hydrateRoot(root, tree);
} else {
  if (root.firstChild) root.innerHTML = '';
  createRoot(root).render(tree);
}
